import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaStar,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaMagic,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const GreenScreenVideoShootsInDIFC = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Green Screen Video Shoots in DIFC" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Unleash Your Creativity</Subheading>}
        heading={
          <Heading>
            Green Screen <span tw="text-primary-500">Video Shoots</span> in DIFC
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, we offer professional green screen video shoots
            in **DIFC**, delivering versatile, high-quality, and visually
            stunning videos. From corporate promos to creative storytelling, our
            green screen technology transforms your vision into reality with
            limitless backgrounds and effects.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1576948187290-457c555687ec?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1601574465779-76d6dbb88557?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1599240211563-17590b1af857?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Start Your Green Screen Video"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Professional Green Screen Video Shoots in DIFC"
        description="We create dynamic videos with cutting-edge technology."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "High-Quality Production",
            description: "Crystal-clear visuals with professional equipment.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Proven success for DIFC clients.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Creative Flexibility",
            description: "Unlimited backgrounds and effects via green screen.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery for tight schedules.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for social media, websites, and ads.",
          },
          {
            icon: <FaMagic color="#ff5464" size={40} />,
            title: "Versatile Applications",
            description: "Ideal for promos, training, and creative projects.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Green Screen Video Production Process"
        description={
          <Description>
            We produce impactful green screen videos with a streamlined process:
            <ul tw="mt-4 list-disc pl-6">
              <li>Consultation: Define your vision and project goals.</li>
              <li>
                Pre-Production: Plan scripts, storyboards, and backgrounds.
              </li>
              <li>
                Filming: Shoot in our state-of-the-art green screen studio.
              </li>
              <li>
                Post-Production: Add custom backgrounds, effects, and editing.
              </li>
              <li>
                Delivery: Provide polished videos ready for your platform.
              </li>
              <li>
                Support: Offer guidance for distribution and optimization.
              </li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1606157689688-4e546b805256?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1615859131861-052f0641a60e?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Green Screen Video Wins in DIFC"
        description="Our green screen videos have transformed projects in DIFC."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Dynamic Campaigns",
            description: "Boosted engagement with creative visuals.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Increased Reach",
            description: "Enhanced visibility across platforms.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Satisfaction",
            description: "96% approval from green screen projects.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Transform Your Vision?</Subheading>}
        heading="Green Screen Video Shoots in DIFC"
        description={
          <Description>
            Partner with MilaajBrandset for green screen video shoots in DIFC.
            Create versatile, high-impact videos that captivate your
            audience—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1526948531399-320e7e40f0ca?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1579546929662-711aa81148cf?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
          "https://images.unsplash.com/photo-1580537659466-0a9bfa916a54?ixlib=rb-4.0.3&auto=format&fit=crop&q=80&w=1000",
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
